// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { useEffect, useState } from 'react';
import { obtenerNoticiasCurso } from '../../store/slices/noticia/thunks';
import { NoticiaState, setNoticia, startLoadingNoticia } from '../../store/slices/noticia';
import { IconButton } from '@mui/material';
// mui icons
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// componentes propios
import CrearNoticia from './CrearNoticia';
import EliminarNoticia from './EliminarNoticia';
import EditarNoticia from './EditarNoticia';
import Latex from 'react-latex-next';

const NoticiasEdicion = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { noticias, isLoading } = useSelector((state: RootState) => state.noticia);
    const { curso } = useSelector((state: RootState) => state.curso);

    useEffect(() => {
      if (curso?.cid) {
        dispatch(obtenerNoticiasCurso(curso.cid));
        dispatch(startLoadingNoticia());
      }
    }, [curso, dispatch])

    // Crear Noticia
    const [openCrear, setOpenCrear] = useState(false);

    const handleClickOpenCrear = () => {
        setOpenCrear(true);
    };

    // Eliminar Noticia
    const [openEliminar, setOpenEliminar] = useState(false);

    const handleEliminarNoticia = (noticia: NoticiaState) => {
        dispatch(setNoticia(noticia));
        setOpenEliminar(true)
    }

    // Editar Noticia
    const [openEditar, setOpenEditar] = useState(false);

    const handleEditarNoticia = (noticia: NoticiaState) => {
        dispatch(setNoticia(noticia));
        setOpenEditar(true)
    }

    if (isLoading) {
        return (
            <div>
                <h2>Noticias</h2>

                <div className="d-flex justify-content-center my-5">
                    <div className="spinner-border" role="status" style={{color: '#3b5998'}}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        ) 
    }
    
    return (
        <div>
            
            {
                openCrear && <CrearNoticia open={openCrear} setOpen={setOpenCrear}/>
            }

            {
                openEliminar && <EliminarNoticia open={openEliminar} setOpen={setOpenEliminar}/>
            }

            {
                openEditar && <EditarNoticia open={openEditar} setOpen={setOpenEditar}/>
            }

            <h2>Noticias</h2>

            <div className="container">
                <div className="row justify-content-end align-items-center">
                    <div className="col-auto px-1" >
                        <IconButton
                            onClick={handleClickOpenCrear}
                            size="small"
                        >
                            <AddIcon />
                        </IconButton>
                    </div>
                    <div className="col-auto px-1">
                        <span style={{color: 'grey'}}>Crear Noticia</span>
                    </div>
                </div>
            </div>

            {
                noticias.map(item => {
                    const {id, fecha, titulo, contenido} = item

                    let date = new Date(fecha)
                    let day = date.getDate()
                    let month = date.toLocaleString('es-US', {
                        month: 'long',
                    });
                    let year = date.getFullYear()

                    return (
                        <div key={id}>
                            <hr style={{backgroundColor: '#3b5998'}} className='mt-b' />

                            <span 
                                style={{backgroundColor: '#3b5998'}} 
                                className="badge"
                            >
                                {day} de {month} de {year}
                            </span>                         

                            <h4 className='my-3'>{titulo}</h4>

                            <Latex>{contenido}</Latex>
                            
                            <div className="row align-items-center mt-2 mb-2">
                                <div className="col-12" >

                                    <IconButton
                                        className='float-end'
                                        onClick={() => handleEliminarNoticia(item)}
                                        size="small"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                    <IconButton
                                        className='float-end'
                                        onClick={() => handleEditarNoticia(item)}
                                        size="small"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </div>
                            </div>
                            
                        </div>
                    )
                })
            }

        </div>
    )
}

export default NoticiasEdicion